import { Link } from "react-router-dom";
import { SeoHead } from "../../seo/SeoHead";
import { buildBreadcrumbListJsonLd } from "../../seo/site";

const SEO_DESCRIPTION =
  "Politique de confidentialité Raguia : données collectées, base légale RGPD, droits, cookies, hébergement.";

export default function PrivacyPage() {
  return (
    <>
      <SeoHead
        title="Politique de confidentialité — Raguia"
        description={SEO_DESCRIPTION}
        jsonLd={buildBreadcrumbListJsonLd([
          { name: "Accueil", path: "/" },
          { name: "Politique de confidentialité", path: "/confidentialite" },
        ])}
      />
      <main className="mx-auto max-w-3xl px-4 py-12 sm:px-6 sm:py-16">
        <h1 className="font-heading text-3xl font-semibold tracking-tight text-[#010101] sm:text-4xl">
          🔒 Politique de confidentialité
        </h1>
        <p className="mt-2 text-sm font-medium text-stone-800">
          Dernière mise à jour : avril 2026
        </p>

        <article className="prose prose-stone mt-10 max-w-none prose-headings:font-semibold prose-headings:text-[#010101] prose-p:text-stone-800 prose-li:text-stone-800 prose-a:text-[#A43032] prose-a:font-semibold prose-strong:text-[#010101]">
          <h2>1. Responsable du traitement</h2>
          <p>
            <strong>Valentin Fiess</strong>,{" "}
            <a href="mailto:pumice-mouse-woof@duck.com">Mail</a>. Questions
            données :{" "}
            <Link to="/contact" className="font-medium">
              formulaire de contact
            </Link>
            .
          </p>

          <h2>2. Données collectées (site vitrine)</h2>
          <p>
            Via le{" "}
            <Link to="/contact" className="font-medium">
              formulaire de contact
            </Link>{" "}
            (devis, démo, feedback, autre) : identité, coordonnées, contenu du
            message. Journaux techniques pouvant être collectés par l’hébergeur
            (sécurité, continuité de service).
          </p>

          <h2>3. Base légale</h2>
          <ul>
            <li>
              <strong>Contact / devis :</strong> intérêt légitime ou mesure
              précontractuelle (RGPD art. 6(1)(b) et (f)).
            </li>
            <li>
              <strong>Amélioration produit :</strong> intérêt légitime.
            </li>
          </ul>

          <h2>4. Destinataires</h2>
          <p>
            Envoi d’e-mails via un prestataire type EmailJS (clauses conformes
            RGPD). Hébergement OVH (Union européenne, France).
          </p>

          <h2>5. Plateforme Raguia (clients)</h2>
          <p>
            Pour les clients de la plateforme SaaS, traitements documents /
            comptes / journaux : convention distincte (contrat, DPA).
          </p>

          <h2>6. Vos droits</h2>
          <p>
            Accès, rectification, effacement, limitation, opposition,
            portabilité — réclamation auprès de la{" "}
            <a
              href="https://www.cnil.fr"
              target="_blank"
              rel="noopener noreferrer"
            >
              CNIL
            </a>
            .
          </p>

          <h2>7. Cookies</h2>
          <p>
            Nous utilisons des cookies Matomo pour analyser le trafic. Les
            cookies Cloudflare présents sont strictement nécessaires à la
            sécurité et exemptés de consentement.
          </p>
        </article>

        <p className="mt-10">
          <Link
            to="/"
            className="text-sm font-medium text-[#A43032] hover:underline"
          >
            ← Retour à l’accueil
          </Link>
        </p>
      </main>
    </>
  );
}
